(function () {
  function whenReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  function whenSwiperReady(callback, retries) {
    if (typeof window.Swiper !== "undefined") {
      callback();
      return;
    }
    var remaining = typeof retries === "number" ? retries : 40;
    if (remaining <= 0) {
      return;
    }
    setTimeout(function () {
      whenSwiperReady(callback, remaining - 1);
    }, 50);
  }

  function initVideoCarouselSection(section) {
    if (!section || section.dataset.videoCarouselInit === "true") {
      return;
    }

    var swiperContainer = section.querySelector(".swiper-container");
    if (!swiperContainer) {
      return;
    }

    var slides = section.querySelectorAll(".swiper-slide");
    if (!slides.length) {
      return;
    }

    section.dataset.videoCarouselInit = "true";

    function updateDeviceClass() {
      if (window.innerWidth > 768) {
        swiperContainer.classList.add("desktop");
        swiperContainer.classList.remove("mobile");
      } else {
        swiperContainer.classList.add("mobile");
        swiperContainer.classList.remove("desktop");
      }
    }

    function getSlidesPerView() {
      var containerWidth = swiperContainer.clientWidth;
      var isMobile = window.innerWidth <= 768;
      var normalSlideWidth = isMobile ? 200 : 300;
      var activeSlideWidth = isMobile ? 240 : 368;
      return (containerWidth - activeSlideWidth) / normalSlideWidth + 1;
    }

    function getSlidesSpacing() {
      var isMobile = window.innerWidth <= 768;
      return isMobile ? 50 : 24;
    }

    updateDeviceClass();

    var prevEl = section.querySelector(".video-carousel-arrow-left");
    var nextEl = section.querySelector(".video-carousel-arrow-right");

    var swiperOptions = {
      slidesPerView: getSlidesPerView(),
      centeredSlides: true,
      spaceBetween: getSlidesSpacing(),
      loop: true,
      observer: true,
      observeParents: true,
    };

    if (prevEl && nextEl) {
      swiperOptions.navigation = {
        nextEl: nextEl,
        prevEl: prevEl,
      };
    }

    var swiper;

    function updateOverlayActiveSlides(track) {
      if (!track) {
        return;
      }

      var trackRect = track.getBoundingClientRect();
      var carouselSlides = track.querySelectorAll(".swiper-slide");

      carouselSlides.forEach(function (slide) {
        var rect = slide.getBoundingClientRect();
        var isPartiallyVisible =
          rect.right > trackRect.left && rect.left < trackRect.right;
        var isClipped =
          isPartiallyVisible &&
          (rect.left < trackRect.left - 1 || rect.right > trackRect.right + 1);

        slide.classList.toggle("overlay-active", isClipped);
      });
    }

    function scheduleOverlayUpdate() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          updateOverlayActiveSlides(section);
        });
      });
    }

    function resetAllVideos() {
      section.querySelectorAll(".swiper-slide video").forEach(function (video) {
        video.pause();
        video.style.display = "none";
        video.removeAttribute("controls");

        var slide = video.closest(".swiper-slide");
        if (!slide) {
          return;
        }

        var playBtn = slide.querySelector(".video_play");
        var thumb = slide.querySelector(".video-thumbnail");
        var title = slide.querySelector(".video-title-overlay");

        if (playBtn) {
          playBtn.style.display = "block";
        }
        if (thumb) {
          thumb.style.display = "block";
        }
        if (title) {
          title.style.display = "block";
        }
      });
    }

    function runInitialOverlayUpdate() {
      if (!swiper) {
        return;
      }

      swiper.update();
      scheduleOverlayUpdate();
      setTimeout(function () {
        if (!swiper) {
          return;
        }
        swiper.update();
        updateOverlayActiveSlides(section);
      }, 50);
      setTimeout(function () {
        updateOverlayActiveSlides(section);
      }, 200);
    }

    swiperOptions.on = {
      init: function (swiperInstance) {
        swiper = swiperInstance;
        runInitialOverlayUpdate();
      },
      loopFix: function () {
        updateOverlayActiveSlides(section);
      },
      slideChange: function () {
        resetAllVideos();
        scheduleOverlayUpdate();
      },
      transitionEnd: function () {
        updateOverlayActiveSlides(section);
      },
      resize: function () {
        updateOverlayActiveSlides(section);
      },
      setTranslate: function () {
        updateOverlayActiveSlides(section);
      },
      observerUpdate: function () {
        scheduleOverlayUpdate();
      },
    };

    swiper = new Swiper(swiperContainer, swiperOptions);

    section.querySelectorAll("img").forEach(function (image) {
      if (image.complete) {
        return;
      }

      function handleImageReady() {
        image.removeEventListener("load", handleImageReady);
        image.removeEventListener("error", handleImageReady);
        scheduleOverlayUpdate();
      }

      image.addEventListener("load", handleImageReady);
      image.addEventListener("error", handleImageReady);
    });

    if (document.readyState === "complete") {
      runInitialOverlayUpdate();
    } else {
      window.addEventListener("load", runInitialOverlayUpdate, { once: true });
    }

    window.addEventListener("resize", function () {
      updateDeviceClass();
      var newSlidesPerView = getSlidesPerView();
      if (swiper.params.slidesPerView !== newSlidesPerView) {
        swiper.params.slidesPerView = newSlidesPerView;
        swiper.update();
      }
      updateOverlayActiveSlides(section);
    });

    swiperContainer.addEventListener("click", function (e) {
      var activeSlide = swiperContainer.querySelector(".swiper-slide.swiper-slide-active");
      if (!activeSlide || !activeSlide.contains(e.target)) {
        return;
      }

      if (!e.target.closest(".video-wrapper")) {
        return;
      }

      var video = activeSlide.querySelector("video");
      var playBtn = activeSlide.querySelector(".video_play");
      var thumb = activeSlide.querySelector(".video-thumbnail");
      var title = activeSlide.querySelector(".video-title-overlay");

      if (!video) {
        return;
      }

      e.preventDefault();

      if (video.paused) {
        resetAllVideos();
        video.style.display = "block";
        if (playBtn) {
          playBtn.style.display = "none";
        }
        if (thumb) {
          thumb.style.display = "none";
        }
        if (title) {
          title.style.display = "none";
        }

        video.muted = false;
        video.play().catch(function (error) {
          console.warn("Không thể play video:", error);
        });
        video.removeAttribute("controls");
      } else {
        video.pause();
        video.muted = true;
        video.style.display = "none";
        if (playBtn) {
          playBtn.style.display = "block";
        }
        if (thumb) {
          thumb.style.display = "block";
        }
        if (title) {
          title.style.display = "block";
        }
        video.removeAttribute("controls");
      }
    });

    resetAllVideos();

    section.querySelectorAll(".swiper-slide").forEach(function (slide) {
      slide.style.cursor = "pointer";
      slide.addEventListener("click", function (e) {
        if (
          e.target.tagName.toLowerCase() === "video" ||
          e.target.classList.contains("video_play")
        ) {
          return;
        }

        var realIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        if (isNaN(realIndex)) {
          return;
        }

        var activeSlide = swiperContainer.querySelector(".swiper-slide.swiper-slide-active");
        if (!activeSlide) {
          return;
        }

        var activeIndex = parseInt(activeSlide.getAttribute("data-swiper-slide-index"), 10);
        if (isNaN(activeIndex) || realIndex === activeIndex) {
          return;
        }

        swiper.slideToLoop(realIndex);
      });
    });
  }

  function initAllVideoCarousels(scope) {
    var root = scope || document;
    root.querySelectorAll(".video-carousel-section").forEach(initVideoCarouselSection);
  }

  if (!window.__videoCarouselEventsBound) {
    window.__videoCarouselEventsBound = true;

    whenReady(function () {
      whenSwiperReady(function () {
        initAllVideoCarousels();
      });
    });

    document.addEventListener("shopify:section:load", function (event) {
      whenSwiperReady(function () {
        initAllVideoCarousels(event.target);
      });
    });
  }

  whenSwiperReady(function () {
    initAllVideoCarousels();
  });
})();
